<div class="geocoder-dialog">
  <tui-textarea
    [expandable]="true"
    [tuiHintContent]="'components.geocoder.labels.hintMultipleInput' | translate"
    [(ngModel)]="textValue"
  >
    {{ 'components.geocoder.fields.enterAddresses' | translate }}
  </tui-textarea>

  <button tuiButton type="button" [loading]="loading" (click)="addMapObjects()">
    {{ 'common.buttons.add' | translate }}
  </button>
</div>
